export var SIDEBAR_EXPANDED_WIDTH = '256px';
export var SIDEBAR_COLLAPSED_WIDTH = '112px';
export var NEW_DASHBOARD_TEMPLATE_ID = 'new-dashboard-template';